<template>
    <v-app :style="{ background: $vuetify.theme.currentTheme.background }">

        <v-main>
            <!-- ── Tablet master-detail: Programma ──────────────────── -->
            <div v-if="isTablet && $route.name === 'programma'" class="tablet-split">
                <div class="tablet-master">
                    <keep-alive>
                        <router-view />
                    </keep-alive>
                </div>
                <div class="tablet-detail">
                    <div class="tablet-detail-inner">
                        <ProgrammaEdit
                            v-if="tabletState.detailProgramma && tabletState.detailProgramma.type === 'standard'"
                            :key="'pedit-' + (tabletState.detailProgramma.id || tabletState.detailProgramma.data)"
                            :inline-id="tabletState.detailProgramma.id"
                            :inline-tipo="tabletState.detailProgramma.tipo"
                            :inline-data="tabletState.detailProgramma.data"
                            :inline-id-congregazione="tabletState.detailProgramma.idCongregazione"
                            @close="tabletState.detailProgramma = null"
                        />
                        <ProgrammaExtraInterno
                            v-else-if="tabletState.detailProgramma && tabletState.detailProgramma.type === 'extra-interno'"
                            :key="'pei-' + (tabletState.detailProgramma.id || tabletState.detailProgramma.data)"
                            :inline-id="tabletState.detailProgramma.id"
                            :inline-data="tabletState.detailProgramma.data"
                            :inline-id-congregazione="tabletState.detailProgramma.idCongregazione"
                            @close="tabletState.detailProgramma = null"
                        />
                        <ProgrammaExtraEsterno
                            v-else-if="tabletState.detailProgramma && tabletState.detailProgramma.type === 'extra-esterno'"
                            :key="'pee-' + (tabletState.detailProgramma.id || tabletState.detailProgramma.data)"
                            :inline-id="tabletState.detailProgramma.id"
                            :inline-data="tabletState.detailProgramma.data"
                            :inline-id-congregazione="tabletState.detailProgramma.idCongregazione"
                            @close="tabletState.detailProgramma = null"
                        />
                    </div>
                    <div v-if="!tabletState.detailProgramma" class="tablet-detail-placeholder">
                        <v-icon size="64" color="grey lighten-1">mdi-calendar-outline</v-icon>
                        <p class="text-caption grey--text mt-2">Seleziona un appuntamento</p>
                    </div>
                </div>
            </div>

            <!-- ── Tablet master-detail: Schemi ─────────────────────── -->
            <div v-else-if="isTablet && $route.name === 'schemi'" class="tablet-split">
                <div class="tablet-master">
                    <keep-alive>
                        <router-view />
                    </keep-alive>
                </div>
                <div class="tablet-detail">
                    <div class="tablet-detail-inner">
                        <Schema
                            v-if="tabletState.detailSchemaId"
                            :key="'schema-' + tabletState.detailSchemaId"
                            :schema-id="tabletState.detailSchemaId"
                            @close="tabletState.detailSchemaId = null"
                        />
                        <OratoriDiscorso
                            v-else-if="tabletState.detailDiscorso"
                            :key="'discorso-' + tabletState.detailDiscorso.id"
                            :discorso="tabletState.detailDiscorso"
                        />
                    </div>
                    <div v-if="!tabletState.detailDiscorso && !tabletState.detailSchemaId" class="tablet-detail-placeholder">
                        <v-icon size="64" color="grey lighten-1">mdi-file-document-outline</v-icon>
                        <p class="text-caption grey--text mt-2">Seleziona uno schema</p>
                    </div>
                </div>
            </div>

            <!-- ── Tablet master-detail: Oratori ────────────────────── -->
            <div v-else-if="isTablet && $route.name === 'oratori'" class="tablet-split">
                <div class="tablet-master">
                    <keep-alive>
                        <router-view />
                    </keep-alive>
                </div>
                <div class="tablet-detail">
                    <div class="tablet-detail-inner">
                        <Oratore
                            v-if="tabletState.detailOratoreId"
                            :key="'oratore-list-' + tabletState.detailOratoreId"
                            :inline-id="tabletState.detailOratoreId"
                            :inline-cong-id="tabletState.newOratoreForCongId"
                            :hide-back="true"
                            @close="tabletState.detailOratoreId = null"
                            @saved="tabletState.detailOratoreId = String($event)"
                        />
                    </div>
                    <div v-if="!tabletState.detailOratoreId" class="tablet-detail-placeholder">
                        <v-icon size="64" color="grey lighten-1">mdi-account-outline</v-icon>
                        <p class="text-caption grey--text mt-2">Seleziona un oratore</p>
                    </div>
                </div>
            </div>

            <!-- ── Tablet master-detail: Congregazioni ───────────────── -->
            <div v-else-if="isTablet && $route.name === 'congregazioni'" class="tablet-split">
                <div class="tablet-master">
                    <keep-alive>
                        <router-view />
                    </keep-alive>
                </div>
                <div class="tablet-detail">
                    <div class="tablet-detail-inner">
                    <!-- Priorità: Oratore > lista Oratori > form Congregazione -->
                    <Oratore
                        v-if="tabletState.detailOratoreId"
                        :key="'oratore-' + tabletState.detailOratoreId"
                        :inline-id="tabletState.detailOratoreId"
                        :inline-cong-id="tabletState.newOratoreForCongId"
                        @close="tabletState.detailOratoreId = null"
                        @saved="tabletState.detailOratoreId = String($event)"
                    />
                    <Oratori
                        v-else-if="tabletState.detailOratoriId"
                        :key="'ora-' + tabletState.detailOratoriId"
                        :inline-id-congregazione="tabletState.detailOratoriId"
                        :inline-nome="tabletState.detailOratoriNome"
                        @close="tabletState.detailOratoriId = null"
                    />
                    <Congregazione
                        v-else-if="tabletState.detailCongId"
                        :key="'cong-' + tabletState.detailCongId"
                        :cong-id="tabletState.detailCongId"
                        @close="tabletState.detailCongId = null"
                    />
                    </div>
                    <div v-if="!tabletState.detailOratoreId && !tabletState.detailOratoriId && !tabletState.detailCongId"
                         class="tablet-detail-placeholder">
                        <v-icon size="64" color="grey lighten-1">mdi-hand-pointing-left</v-icon>
                        <p class="text-caption grey--text mt-2">Seleziona una congregazione</p>
                    </div>
                </div>
            </div>
            <!-- ── Default ───────────────────────────────────────────── -->
            <keep-alive v-else>
                <router-view />
            </keep-alive>
        </v-main>

        <!-- Bottom navigation — tutti i dispositivi -->
        <v-bottom-navigation
            v-if="logged"
            :value="currentRoute"
            app
            grow
            color="primary"
            class="bottom-nav-app"
        >
            <v-btn v-if="!isCollaboratore" value="/congregazioni" to="/congregazioni">
                <span>Congregazioni</span>
                <v-icon size="22">mdi-view-grid-outline</v-icon>
            </v-btn>
            <v-btn v-if="mostraOratori" value="/oratori" to="/oratori">
                <span>Oratori</span>
                <v-icon size="22">mdi-account-multiple-outline</v-icon>
            </v-btn>
            <v-btn v-if="!isCollaboratore" value="/schemi" to="/schemi">
                <span>Schemi</span>
                <v-icon size="22">mdi-file-document-outline</v-icon>
            </v-btn>
            <v-btn value="/" to="/">
                <span>Programma</span>
                <v-icon size="22">mdi-calendar-outline</v-icon>
            </v-btn>
            <v-btn :value="altroRouteValue" @click.prevent="openAltro">
                <span>Altro</span>
                <v-icon size="22">mdi-dots-horizontal</v-icon>
            </v-btn>
        </v-bottom-navigation>

        <!-- Menu contestuale: Altro -->
        <v-menu v-model="bottomSheetAltro"
                absolute :position-x="menuAltroX" :position-y="menuAltroY"
                :close-on-content-click="true" min-width="180" rounded="lg">
            <v-list dense>
                <v-list-item v-if="!isCollaboratore" @click="navigaAltro('/ricerche')">
                    <v-list-item-icon class="mr-2">
                        <v-icon small color="primary">mdi-magnify</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Ricerche</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="mostraOratori" @click="navigaAltro('/statistiche')">
                    <v-list-item-icon class="mr-2">
                        <v-icon small color="success">mdi-chart-bar</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Statistiche</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="isSuperAdmin" @click="navigaAltro('/recupero-credenziali')">
                    <v-list-item-icon class="mr-2">
                        <v-icon small color="orange darken-1">mdi-key-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Recupero Credenziali</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="isSuperAdmin" @click="navigaAltro('/admin')">
                    <v-list-item-icon class="mr-2">
                        <v-icon small color="deep-purple darken-1">mdi-shield-crown-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Admin</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="isSuperAdmin" @click="navigaAltro('/nuova-circoscrizione')">
                    <v-list-item-icon class="mr-2">
                        <v-icon small color="primary">mdi-plus-circle-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Nuova Circoscrizione</v-list-item-title>
                </v-list-item>
                <v-divider />
                <v-list-item @click="navigaAltro('/impostazioni')">
                    <v-list-item-icon class="mr-2">
                        <v-icon small color="grey darken-1">mdi-cog-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Impostazioni</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>

        <!-- Info chip login oratore (una tantum per admin) -->
        <v-snackbar v-model="snackChipLogin" bottom multi-line timeout="-1" max-width="340" color="primary" rounded="lg">
            <div class="d-flex align-start" style="gap:8px">
                <v-icon color="white" class="mt-1 flex-shrink-0">mdi-information-outline</v-icon>
                <span class="text-body-2">Come admin di circoscrizione, vedrai accanto a ogni oratore due numeri che indicano i giorni trascorsi dall'ultima connessione app o web.</span>
            </div>
            <template #action>
                <v-btn text small color="white" @click="chiudiSnackChip">OK</v-btn>
            </template>
        </v-snackbar>

        <!-- Overlay server in manutenzione -->
        <v-overlay v-if="serverOffline" z-index="9999" opacity="0.92" color="white" light>
            <div class="d-flex flex-column align-center text-center px-8">
                <v-img src="@/assets/talk_login.png" width="72" height="72" style="border-radius:16px;margin-bottom:16px" contain />
                <v-icon size="36" color="grey lighten-1" class="mb-4">mdi-server-off</v-icon>
                <div class="text-h6 font-weight-bold grey--text text--darken-3 mb-1">
                    Server temporaneamente non disponibile
                </div>
                <div class="text-subtitle-2 grey--text text--darken-1 mb-4">
                    Manutenzione/Aggiornamento in corso
                </div>
                <v-progress-circular indeterminate color="primary" size="28" width="3" />
            </div>
        </v-overlay>


    </v-app>

</template>

<script>

import { callService, callPost, euro, gLocalData, gCheckData, gServerData, Snack, SUPERADMIN_CODE } from '@/modules/utilities.js'
import { bus } from '@/main.js'
import { version } from "/package.json"
import Congregazione from '@/views/Congregazione.vue'
import Oratori from '@/views/Oratori.vue'
import Oratore from '@/views/Oratore.vue'
import OratoriDiscorso from '@/views/OratoriDiscorso.vue'
import Schema from '@/views/Schema.vue'
import ProgrammaEdit from '@/views/ProgrammaEdit.vue'
import ProgrammaExtraInterno from '@/views/ProgrammaExtraInterno.vue'
import ProgrammaExtraEsterno from '@/views/ProgrammaExtraEsterno.vue'

export default {
    components: { Congregazione, Oratori, Oratore, OratoriDiscorso, Schema, ProgrammaEdit, ProgrammaExtraInterno, ProgrammaExtraEsterno },
    data() {
        return {
            applicationVersion: version,
            SUPERADMIN_CODE: '',
            theme: false,
            bottomSheetAltro: false,
            menuAltroX: 0,
            menuAltroY: 0,
            serverOffline: false,
            _healthFailCount: 0, // fallimenti consecutivi prima di mostrare overlay
            snackChipLogin: false,
            // Stato reattivo condiviso con i figli via provide
            tabletState: {
                detailCongId: null, detailOratoriId: null, detailOratoriNome: null, detailOratoreId: null,
                detailDiscorso: null, detailSchemaId: null, detailProgramma: null, newOratoreForCongId: null,
            },
        }
    },
    provide() {
        return {
            tabletState: this.tabletState,
            setDetailCong: (id) => {
                this.tabletState.detailCongId = id;
                this.tabletState.detailOratoriId = null;
                this.tabletState.detailOratoriNome = null;
                this.tabletState.detailOratoreId = null;
            },
            setDetailOratori: (id, nome) => {
                this.tabletState.detailOratoriId = String(id);
                this.tabletState.detailOratoriNome = nome;
                this.tabletState.detailCongId = null;
                this.tabletState.detailOratoreId = null;
            },
            setDetailOratore: (id, congId = null) => {
                // Mantiene detailOratoriId/Nome così il back torna alla lista
                this.tabletState.detailOratoreId = String(id);
                this.tabletState.newOratoreForCongId = congId;
            },
            setDetailDiscorso: (discorso) => {
                this.tabletState.detailDiscorso = discorso;
                this.tabletState.detailSchemaId = null;
            },
            setDetailSchema: (id) => {
                this.tabletState.detailSchemaId = id;
                this.tabletState.detailDiscorso = null;
            },
            setDetailProgramma: (detail) => {
                // detail: { type, id, data, tipo } oppure null per chiudere
                this.tabletState.detailProgramma = detail;
            },
            clearDetail: () => {
                this.tabletState.detailCongId = null;
                this.tabletState.detailOratoriId = null;
                this.tabletState.detailOratoriNome = null;
                this.tabletState.detailOratoreId = null;
                this.tabletState.detailDiscorso = null;
                this.tabletState.detailProgramma = null;
            },
        }
    },
    name: 'App',
    computed: {
        isTablet() {
            return this.$vuetify.breakpoint.mdAndUp;
        },
        logged() {
            return this.$store.state.logged
        },
        isCollaboratore() {
            return this.$store.state.isCollaboratore || false;
        },
        mostraOratori() {
            if (this.isCollaboratore) return false;
            return this.$store.state.oratore && (
                this.$store.state.oratore.codice == this.SUPERADMIN_CODE ||
                this.$store.state.oratore.isAdmin ||
                this.$store.state.oratore.isCoordinatore ||
                this.$store.state.oratore.isAssistente
            );
        },
        currentRoute() {
            return this.$route.path;
        },
        isSuperAdmin() {
            return this.$store.state.oratore?.codice == this.SUPERADMIN_CODE ||
                   this.$store.state.loginCodice == this.SUPERADMIN_CODE ||
                   this.$store.state.loginCodice == 250613 ||
                   this.$store.state.loginInputCodice == 250613;
        },
        altroRouteValue() {
            const altroRoutes = ['/impostazioni', '/ricerche', '/statistiche', '/nuova-circoscrizione', '/recupero-credenziali', '/admin'];
            return altroRoutes.includes(this.$route.path) ? this.$route.path : '__altro__';
        }
    },
    methods: {
        async _loadTalkShards() {
            try {
                const res = await fetch(process.env.VUE_APP_SERVER + '/api/batch/shards');
                if (res.ok) {
                    const shards = await res.json();
                    this.$store.commit('setTalkShards', shards);
                }
            } catch (e) {
                // non bloccante — la UI degrada mostrando l'appId grezzo
            }
        },
        async _syncOneSignalTag(val) {
            if (!val || !window.HybridWebView) return;
            if (!this.$store.state.logged) return;
            if (val._partition) {
                // Legge shard fresco dal server — l'admin può averlo cambiato dall'esterno
                let _appId = this.$store.state.onesignalShardAppId || val._partition;
                try {
                    const _res = await fetch(process.env.VUE_APP_SERVER + '/api/batch/checkshard?partition=' + encodeURIComponent(val._partition));
                    if (_res.ok) {
                        const _json = await _res.json();
                        if (_json.appId) {
                            _appId = _json.appId;
                            this.$store.state.onesignalShardAppId = _json.appId;
                        }
                    }
                } catch (_) { /* usa il valore in store */ }
                const shardResult = await this.$callMaui('InitTalkOneSignal', _appId);
                if (shardResult === 'RESTART_REQUIRED') return;
            }
            const ruolo = val.isAdmin        ? 'App-Admin'
                        : val.isCoordinatore ? 'Coordinatore'
                        : val.isAssistente   ? 'Assistente'
                        : val.isSM           ? 'Servo Ministeriale'
                        : val.isAnziano      ? 'Anziano'
                        : 'Oratore';
            const name     = `${val.nome} ${val.cognome} - ${ruolo}`;
            const userName = `${val.codice}-${val._partition}`;
            // Delay: dà tempo a OneSignal di completare la subscription dopo InitTalkOneSignal
            setTimeout(() => {
                if (this.$store.state.logged) {
                    this.$callMaui('SetOneSignalTagsMap', `Name=${name}|UserName=${userName}`);
                }
            }, 5000);
        },
        _checkSnackChipLogin(val) {
            if (!val) return;
            const isAdmin = val.codice == this.SUPERADMIN_CODE || val.isAdmin;
            if (!isAdmin) return;
            const key = `talk_chip_login_info_${val.codice}`;
            if (!localStorage.getItem(key)) this.snackChipLogin = true;
        },
        chiudiSnackChip() {
            this.snackChipLogin = false;
            const codice = this.$store.state.oratore?.codice;
            if (codice) localStorage.setItem(`talk_chip_login_info_${codice}`, '1');
        },
        openAltro(e) {
            this.menuAltroX = e.clientX;
            this.menuAltroY = e.clientY;
            this.$nextTick(() => { this.bottomSheetAltro = true; });
        },
        navigaAltro(path) {
            this.bottomSheetAltro = false;
            if (this.$route.path !== path) this.$router.push(path);
        },
        async switchTheme() {
            this.$vuetify.theme.dark = this.theme;
            const val = this.theme ? 'dark' : 'light';
            localStorage.setItem('user_theme', val);
            this.applyBodyTheme(this.theme);
            if (window.HybridWebView) {
                this.$callMaui('ThemeChanged', val);
            }
        },
        applyBodyTheme(dark) {
            const bg = dark ? '#121212' : '#ffffff';
            document.documentElement.style.backgroundColor = bg;
            document.body.style.backgroundColor = bg;
        },
        _dispatchTalkNotification(payload) {
            // payload = "tab|YYYYMMDD"  es. "1|20250614"
            if (!payload) return;
            // Salva sempre in window: se Programma.vue non è ancora montato
            // (cold start) lo leggerà lui stesso dopo internalCreated()
            window._pendingTalkNotification = payload;
            // Porta in primo piano il calendario
            if (this.$route.name !== 'programma') {
                this.$router.replace({ name: 'programma' });
            }
            // Emetti anche via bus: se Programma.vue è già montato (warm/hot start)
            // il listener gestisce subito e cancella window._pendingTalkNotification
            bus.$emit('talk-notification', payload);
        },
        async _checkHealth() {
            try {
                const ctrl = new AbortController();
                const timeout = setTimeout(() => ctrl.abort(), 5000);
                const res = await fetch(process.env.VUE_APP_SERVER + '/api/health', { signal: ctrl.signal });
                clearTimeout(timeout);
                if (res.ok) {
                    this._healthFailCount = 0;
                    this.serverOffline = false;
                    console.log('[health] ok');
                } else {
                    this._healthFailCount++;
                    if (this._healthFailCount >= 2) this.serverOffline = true;
                    console.log('[health] ko (fallimenti consecutivi:', this._healthFailCount, ')');
                }
            } catch (e) {
                this._healthFailCount++;
                if (this._healthFailCount >= 2) this.serverOffline = true;
                console.log('[health] errore (fallimenti consecutivi:', this._healthFailCount, '):', e.message);
            }
        },
        async _refreshOratore() {
            if (!this.$store.state.logged || !this.$store.state.oratore) return;
            const ownId = this.$store.state.oratore.id;
            if (!ownId) return;
            try {
                const lista = await callService(
                    '/api/oratore?idOratore=' + ownId,
                    [this.$store.state.idCircoscrizione]
                );
                if (!lista || !lista.length) return;
                this.$store.commit('updateOratore', lista[0]);
            } catch {
                // silently ignore
            }
        },
    },
    watch: {
        serverOffline(val, old) {
            // Server tornato online dopo essere stato offline: ricarica la pagina
            if (old === true && val === false) {
                console.log('[health] server tornato online, ricarico...');
                window.location.reload();
            }
        },
        '$route.name'() {
            // reset tutto ad ogni cambio route
            this.tabletState.detailCongId = null;
            this.tabletState.detailOratoriId = null;
            this.tabletState.detailOratoriNome = null;
            this.tabletState.detailOratoreId = null;
            this.tabletState.detailDiscorso = null;
            this.tabletState.detailSchemaId = null;
        },
        logged(val) {
            if (val) {
                this.$updaterHub.connect(this.$store.state.partition);
            } else {
                this.$updaterHub.disconnect();
            }
        },
        '$store.state.oratore'(val) {
            this._checkSnackChipLogin(val);
            this._syncOneSignalTag(val);
        },
        '$updaterHub.signals.oratori'() {
            this._refreshOratore();
        },
    },
    created() {
        this.SUPERADMIN_CODE = SUPERADMIN_CODE;
        this._checkSnackChipLogin(this.$store.state.oratore);
        this._loadTalkShards();

        const savedTheme = localStorage.getItem('user_theme');
        if (savedTheme) {
            this.theme = savedTheme === 'dark';
        } else if (!window.HybridWebView) {
            this.theme = this.$cookie.get('theme') == "true";
        }
        this.$vuetify.theme.dark = this.theme;
        this.applyBodyTheme(this.theme);
        this.$updaterHub.$on('cliente-changed', this.onClienteChanged);
    },
    destroyed() {
        this.$updaterHub.$off('cliente-changed', this.onClienteChanged);
        clearInterval(this._healthTimer);
    },
    mounted() {
        if (!this.$store.state.logged) {
            this.$router.replace({ name: "login" });
        } else {
            this.$updaterHub.connect(this.$store.state.partition);
            // Auto-login: HybridWebView è disponibile qui, non in created()
            this._syncOneSignalTag(this.$store.state.oratore);
        }
        // Sincronizza subito il tema con MAUI al cold start
        if (window.HybridWebView) {
            this.$callMaui('ThemeChanged', this.theme ? 'dark' : 'light');
            // Notifiche Talk in sospeso (cold start: app aperta dal tap sulla notifica)
            this.$callMaui('CheckPendingTalkNotification').then(payload => {
                if (payload) this._dispatchTalkNotification(payload);
            }).catch(() => {});
        }
        // Handler per notifiche Talk quando l'app è già aperta
        window.onTalkNotificationReceived = (payload) => {
            this._dispatchTalkNotification(payload);
        };


        // Healthcheck: ritardo iniziale di 5s per dare tempo alla rete di stabilizzarsi
        setTimeout(() => {
            this._checkHealth();
            this._healthTimer = setInterval(() => this._checkHealth(), 30000);
        }, 5000);
    },
}</script>

<style>
table.v-table tbody td {
    font-size: 28px !important;
}

/* ── Tablet master-detail ───────────────────────────────────── */
.tablet-split {
    display: flex;
    /* Altezza esplicita: viewport meno bottom nav e safe area */
    height: calc(100vh - 56px - env(safe-area-inset-bottom));
    overflow: hidden;
}
.tablet-master {
    width: 40%;
    min-width: 280px;
    max-width: 480px;
    overflow-y: auto;
    overflow-x: hidden;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    flex-shrink: 0;
}
.theme--dark .tablet-master {
    border-right-color: rgba(255, 255, 255, 0.12);
}
.tablet-detail {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
}
.tablet-detail-inner {
    max-width: 640px;
    margin: 0 auto;
}
.tablet-detail-placeholder {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

/* ── Bottom navigation (tutti i dispositivi) ────────────────── */
.bottom-nav-app {
    padding-bottom: env(safe-area-inset-bottom) !important;
    height: calc(56px + env(safe-area-inset-bottom)) !important;
    border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}
.theme--dark .bottom-nav-app {
    border-top: 1px solid rgba(255, 255, 255, 0.12) !important;
}
.bottom-nav-app .v-btn {
    min-width: 0 !important;
}
.bottom-nav-app .v-btn span {
    font-size: 10px !important;
    letter-spacing: 0 !important;
}
@media (max-width: 360px) {
    .bottom-nav-app .v-btn span {
        font-size: 8px !important;
    }
}

/* ── Dark mode: card più scure per differenziarsi dallo sfondo ── */
.theme--dark .v-card {
    background-color: #272727 !important;
}
.theme--dark.v-application {
    background-color: #121212 !important;
}
</style>
